import React from "react";
import './mergepopup.css';
import {Button, Card, Checkbox, Col, Divider, Row} from 'antd';
import {mergeProjects, updateProject} from "../../api";
import { CloseOutlined } from '@ant-design/icons';

class MergeProject extends React.Component {
    constructor(props) {
        super(props);
        this.startProject = this.startProject.bind(this);
    }

    state = {
        mergeBtnDisabled: true,
        seperateBtnDisabled: false,
        selectedIds: ''
    };

    //keep separate will call this function
    async startProject() {
        const {
            setActiveProject
        } = this.props.context;

        let {project} = this.props;

        const newAttributes = {
            projectStatus: "D",
        };

        const updatedProject = {
            ...project,
            ...newAttributes
        };
        await updateProject(updatedProject);

        setActiveProject(updatedProject);
        this.props.handleAccept(project);
    }

    //After the merge done, this function takes us to project details
    async gotoMergeProjectDtls(projectM) {
        const {
            context, handleMergeAccept
        } = this.props;

        const newAttributes = {
            projectStatus: "D",
        };

        const updatedProject = {
            ...projectM,
            ...newAttributes
        };
        //await updateProject(updatedProject);
        context.setActiveProject(updatedProject);
        handleMergeAccept(projectM);
    }

    //this function is calling backed service to merge projects
    //actual merge happens here
    async mergeSelectedProjects() {
        //get selected project ids only
        //get text box value and pass it to service as project name
        let mergeRequest = {};
        mergeRequest.projects = this.state.selectedIds;
        let projectM = await mergeProjects(mergeRequest);
        //after getting the above response go to merge project details page
        this.gotoMergeProjectDtls(projectM);
    }

    checkProjLength(value) {
        this.setState({selectedIds: value});

        this.setState({mergeBtnDisabled: value.length < 2});
        this.setState({seperateBtnDisabled: value.length > 1});
    }

    render() {
        const {project, duplicateProjects} = this.props;
        return (
            <Card
                title={"Merge Projects?"}
                extra={[<CloseOutlined onClick={this.props.handleClose}/>]}
                actions={[<Button
                    id={'yesMergeBtn'}
                    type={"link"}
                    style={{height: 'auto'}}
                    disabled={this.state.mergeBtnDisabled}
                    onClick={() => this.mergeSelectedProjects()}
                >
                    Yes, Merge
                </Button>,
                    <Button
                        type={"link"}
                        style={{height: 'auto'}}
                        disabled={this.state.seperateBtnDisabled}
                        onClick={this.startProject.bind(this)}
                    >
                        No, Keep Separate
                    </Button>]}
                headStyle={{fontWeight: 700, fontSize: "20px"}}
            >
                There are more than one Upcoming Projects at this Station<br/>
                {"      "} Do you want to merge these projects?
                <Divider/>

                <div className="cpm-ovf">
                    <Checkbox.Group style={{width: '100%'}} onChange={(value) => this.checkProjLength(value)} defaultValue={[project.id]}>
                    {duplicateProjects && duplicateProjects.map(dup => (
                        <Row gutter={16}>
                            <Col span={2}>
                                <Checkbox
                                    className="merge-chk"
                                    checked={dup.id === project.id}
                                    name="chkProj"
                                    id={'chkBox' + dup.id}
                                    value={dup.id}
                                />
                            </Col>
                            <Col span={22}>
                                <b>{dup.stationName}</b>
                                <br/>
                                <b>BPID: </b> {dup.bpid} <br/>
                                <b> Construction Start Date: </b>{" "}
                                {dup.constructionStartDate}
                                <hr/>
                            </Col>
                        </Row>
                    ))}
                    </Checkbox.Group>
                </div>
            </Card>
        );
    }
}

export default MergeProject;
